import Clarity from '@microsoft/clarity'

import { logger } from '@/lib/logger'

/**
 * Initialize Microsoft Clarity
 */
export const initClarity = (): void => {
  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID

  if (!projectId) {
    logger.error('Clarity project ID not found in environment variables')
    return
  }

  try {
    Clarity.init(projectId)

    logger.info('Clarity initialized successfully')
  } catch (error) {
    logger.error('Failed to initialize Clarity', { error })
  }
}
